import axios from 'axios';
import api from './api';
import { API_URL } from '../config';

export const dailyDealService = {
  getDailyDeals: async () => {
    try {
      const response = await api.get('/daily-deals');
      return response.data.dailyDeals || [];
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(`Error al obtener ofertas diarias: ${error.response?.data?.error || error.message}`);
      }
      throw error;
    }
  },

  getDailyDealsWithPagination: async (page: number = 1, limit: number = 10) => {
    try {
      const response = await api.get(`/daily-deals?page=${page}&limit=${limit}`);
      return {
        dailyDeals: response.data.dailyDeals || [],
        currentPage: response.data.currentPage || 1,
        totalPages: response.data.totalPages || 1,
        total: response.data.total || 0,
        hasNext: response.data.hasNext || false,
        hasPrev: response.data.hasPrev || false
      };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(`Error al obtener ofertas diarias: ${error.response?.data?.error || error.message}`);
      }
      throw error;
    }
  },

  createDailyDeal: async (dealData: any) => {
    try {
      if (!dealData.product_id) {
        throw new Error('Se requiere seleccionar un producto');
      }

      const response = await api.post('/daily-deals', dealData);
      
      if (!response.data) {
        throw new Error('No se recibió respuesta del servidor');
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.error || error.message;
        throw new Error(`Error al crear la oferta diaria: ${errorMessage}`);
      }
      throw error;
    }
  },

  updateDailyDeal: async (id: string, dealData: any) => {
    try {
      if (!id) {
        throw new Error('Se requiere el ID de la oferta');
      }
      const response = await api.put(`/daily-deals/${id}`, dealData);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.error || error.message;
        throw new Error(`Error al actualizar la oferta diaria: ${errorMessage}`);
      }
      throw error;
    }
  },

  deleteDailyDeal: async (id: string) => {
    try {
      if (!id) {
        throw new Error('Se requiere el ID de la oferta');
      }
      const response = await api.delete(`/daily-deals/${id}`);
      if (!response.data) {
        throw new Error('No se recibió respuesta del servidor');
      }
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.error || error.message;
        throw new Error(`Error al eliminar la oferta diaria: ${errorMessage}`);
      }
      throw error;
    }
  }
};